import { Form } from 'antd'
import * as React from 'react'

const KFormList: React.FC<React.ComponentProps<typeof Form.List>> = ({ name, ...others }) => (
  <Form.List name={name} {...others} />
)

export default KFormList
